module.exports = __webpack_public_path__ + "media/images/img-all-in-one-a3e65411e1d546b911dfe34aa65aa45f.png";